// React:
import React from "react";
// React-Router-Dom Hooks:
import { useNavigate } from "react-router-dom";
// Redux Toolkit Hooks:
import { useAppSelector } from "../../../app/hooks";
// Redux Toolkit Actions & State:
import { authentication } from "../../authentication/authenticationSlice";
// MUI Components:
import { Container, Typography, Button } from "@mui/material";
// Components:
import BackgroundAnimation from "../../global/background-animation/BackgroundAnimation";
// MUI Styles:
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100vw",
    height: "100vh",
    backgroundColor: theme.palette.background.default,
    overflow: "hidden",
    position: "relative",
  },
  text: {
    color: theme.palette.text.secondary,
    zIndex: 1,
  },
}));

/**
 * @returns This component displays a 403 service unavailable page
 */
const PermissionDenied = () => {
  const classes = useStyles();

  const navigate = useNavigate();

  const { token } = useAppSelector(authentication);

  return (
    <Container
      maxWidth={false}
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        p: { xs: 0 },
      }}
      className={classes.container}
    >
      <BackgroundAnimation />

      <Typography variant="h1" className={classes.text}>
        403
      </Typography>
      <Typography variant="h5" sx={{ mt: 2, mb: 4 }} className={classes.text}>
        Permission Denied !
      </Typography>
      {!!token && (
        <Button
          variant="contained"
          color="secondary"
          sx={{
            fontSize: "16px",
            borderRadius: "8px",
            textTransform: "none",
            lineHeight: "0px",
            padding: "20px",
          }}
          onClick={() => navigate("/")}
        >
          Home page
        </Button>
      )}
    </Container>
  );
};

export default PermissionDenied;
